module.exports = __webpack_public_path__ + "img/visualization.a9510335.png";